import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const NOTIFICATIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SEND_PRIVATE_NOTIFICATION: '/send-private-notification/',
    LIST_NOTIFICATION: '/admin/list-notification',
    TOGGLE_READ_NOTIFICATION: (id: number) => `/admin/toggle-read-notification/${id}/`,
    NOTIFICATION_TYPE_LIST: '/admin/notification-type-list/',
    PRIVATE_NOTIFICATION_DETAIL: (id: number) => `/get-private-notification-for-user/${id}`,
    GENERAL_NOTIFICATION: '/admin/list-general-notifications',
    GENERAL_NOTIFICATION_TYPE_LIST: '/admin/list-general-notification-types',
    CREATE_GENERAL_NOTIFICATION: '/admin/create-general-notification',
  }),
} as const;
